/**
 * The bag (`/shop/bag`, studio-shop D4): the `shop-bag` piece as a page, on
 * every site. Built once for the website (the shop is website-only, the escape
 * hatch in docs/architecture/shared-client-screens.md).
 */
import { ShopBag } from '../../pieces/shop-bag';
import shared from '../../styles/shared.module.css';
import { usePageTitle } from '../../ui/usePageTitle';
import css from './ShopPages.module.css';

export function ShopBagPage() {
  usePageTitle('Your bag');
  return (
    <div className={`${shared.wrap} ${css.flow} ${css.narrow}`}>
      <ShopBag />
    </div>
  );
}
